/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { useEffect, ReactElement } from 'react';
import { useLocation } from 'react-router-dom';

const CloseTab = ({ children }: { children: ReactElement }): ReactElement => {
	const location = useLocation();

	// close tab if url contains #/close-tab
	useEffect(() => {
		if (location.pathname === '/close-tab') {
			window.close();
		}
	}, [location.pathname]);

	return children;
};

export default CloseTab;
